import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { PAGE_INITIAL_VALUE, ROWS_PER_PAGE_OPTION } from 'common/constants';
import { Fragment } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setFilterCurrentPage, setFilterRowsPerPage } from 'v3/data/store/Rank/RankSeller/actions';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { SellerRankListMobile } from 'v3/shared/components/MobileTable/SellerRankMobileTable';
import { PaperStyled, TableCellStyled, TablePaginationStyles } from 'v3/shared/components/Table/RankSellerTable/styles';
import { SubtitleMedium, SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';
import { NoItemsFound } from '../../NoItemsFound';
import { BoxCustom, TableCellGroup, TableMobilePaginationStyles, TableRowStyled } from '../styles';

export const SellerRankTable = () => {
  const { isMobile } = useBreakpoints();
  const { page, rowsPerPage } = useStoreSelector((store) => store.rankSeller.filter);
  const { items, count } = useStoreSelector((store) => store.rankSeller.list);

  if (!Array.isArray(items) || items.length === 0) {
    return <NoItemsFound />;
  }

  const namesColumns = ['Grupo', 'Loja', 'Nome', 'Vendas'];

  return (
    <Fragment>
      {!isMobile ? (
        <BoxCustom>
          <PaperStyled>
            <TableContainer sx={{ maxHeight: 450 }}>
              <TableMui stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {namesColumns.map((names) => (
                      <TableCellStyled>
                        <SubtitleMediumBold>{names} </SubtitleMediumBold>
                      </TableCellStyled>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((store) => (
                    <TableRowStyled hover key={store.id}>
                      <TableCellGroup>
                        <SubtitleMedium>{store.group}</SubtitleMedium>
                      </TableCellGroup>
                      <TableCellGroup>
                        <SubtitleMedium>{store.store}</SubtitleMedium>
                      </TableCellGroup>
                      <TableCellGroup>
                        <SubtitleMedium>{store.sellerName}</SubtitleMedium>
                      </TableCellGroup>
                      <TableCellGroup>
                        <SubtitleMedium>{store.sales}</SubtitleMedium>
                      </TableCellGroup>
                    </TableRowStyled>
                  ))}
                </TableBody>
              </TableMui>
            </TableContainer>
          </PaperStyled>

          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTION}
            component="div"
            sx={TablePaginationStyles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, value) => setFilterCurrentPage(value)}
            onRowsPerPageChange={(event) => {
              setFilterCurrentPage(PAGE_INITIAL_VALUE);
              setFilterRowsPerPage(Number(event.target.value));
            }}
          />
        </BoxCustom>
      ) : (
        <Fragment>
          <SellerRankListMobile />
          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTION}
            component="div"
            sx={TableMobilePaginationStyles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage="Cards por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            onPageChange={(event, value) => setFilterCurrentPage(value)}
            onRowsPerPageChange={(event) => {
              setFilterCurrentPage(PAGE_INITIAL_VALUE);
              setFilterRowsPerPage(Number(event.target.value));
            }}
          />
        </Fragment>
      )}
    </Fragment>
  );
};
